import '@fontsource/anek-latin/500.css';
import '@fontsource/anek-latin/600.css';
import '@fontsource/anek-latin/700.css';
import '@fontsource/mukta/400.css';
import '@fontsource/mukta/500.css';
import '@fontsource/mukta/600.css';
import '@fontsource/mukta/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/account.css';
import './styles/chat.css';
import './styles/business.css';
import './styles/returns.css';
import './styles/sales.css';
import './styles/imports.css';
import './styles/notifications.css';
import './styles/people.css';
import './styles/records.css';
import './styles/privacy.css';
import './styles/admin.css';
import './lib/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initSentry } from './lib/sentry';

void initSentry();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
